export interface Comic {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  description: string;
  chapters: Chapter[];
  tags: string[];
  updatedAt: string;
}

export interface Chapter {
  id: number;
  title: string;
  number: number;
  updatedAt: string;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Solo%20Leveling%20cover%20art%20style%2C%20dark%20fantasy%20male%20hunter%20with%20purple%20glowing%20eyes%2C%20dramatic%20lighting%2C%20action%20pose%2C%20dark%20aesthetic%20background%20with%20shadow%20monsters%2C%20comic%20illustration%20style%2C%20high%20quality%20anime%20art&width=400&height=540&seq=comic-cover-01&orientation=portrait',
    category: 'action',
    status: '已完结',
    rating: 9.8,
    views: '1280万',
    description: '在十年前，世界突然出现了连接异次元与现世的"门"，而其中存在着被称为"猎人"的特殊能力者。成振宇是被称为"人类最弱兵器"的E级猎人，但在一次地下城意外中，他被困在了一个与外界隔绝的残酷世界。濒死的振宇面前出现了一个神秘的系统的任务窗口，这彻底改变了他的人生……从最弱的E级猎人，到无人能敌的S级猎人的成长故事！',
    chapters: [
      { id: 101, title: '第179话 终章', number: 179, updatedAt: '2024-12-20' },
      { id: 102, title: '第178话 觉醒', number: 178, updatedAt: '2024-12-13' },
      { id: 103, title: '第177话 决战前夕', number: 177, updatedAt: '2024-12-06' },
      { id: 104, title: '第176话 影之军团', number: 176, updatedAt: '2024-11-29' },
      { id: 105, title: '第175话 王者归来', number: 175, updatedAt: '2024-11-22' },
      { id: 106, title: '第174话 新的力量', number: 174, updatedAt: '2024-11-15' },
    ],
    tags: ['战斗', '奇幻', '升级', '系统流'],
    updatedAt: '2024-12-20',
  },
  {
    id: 2,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20True%20Beauty%20cover%20style%2C%20beautiful%20female%20character%20with%20makeup%2C%20romance%20comedy%20vibe%2C%20soft%20pink%20and%20warm%20color%20palette%2C%20school%20setting%20background%2C%20comic%20illustration%20style%2C%20high%20quality%20shojo%20art&width=400&height=540&seq=comic-cover-02&orientation=portrait',
    category: 'romance',
    status: '已完结',
    rating: 9.5,
    views: '1560万',
    description: '任朱静因外貌在学校遭受欺凌，便通过化妆变身成为女神般的美女。她在学校里成为了众人追捧的对象，但内心却始终担心自己的真实面貌被揭穿。围绕着天生丽质的女神和靠化妆变美的女主，一段充满欢笑与泪水的校园浪漫故事就此展开。',
    chapters: [
      { id: 201, title: '第263话 终章', number: 263, updatedAt: '2024-10-15' },
      { id: 202, title: '第262话 告白', number: 262, updatedAt: '2024-10-08' },
      { id: 203, title: '第261话 抉择', number: 261, updatedAt: '2024-10-01' },
      { id: 204, title: '第260话 真心', number: 260, updatedAt: '2024-09-24' },
      { id: 205, title: '第259话 重逢', number: 259, updatedAt: '2024-09-17' },
      { id: 206, title: '第258话 成长', number: 258, updatedAt: '2024-09-10' },
    ],
    tags: ['恋爱', '校园', '搞笑', '治愈'],
    updatedAt: '2024-10-15',
  },
  {
    id: 3,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Omniscient%20Reader%20Viewpoint%20cover%20style%2C%20male%20protagonist%20in%20apocalyptic%20world%2C%20fantasy%20novel%20theme%2C%20dramatic%20atmospheric%20lighting%2C%20dystopian%20cityscape%20background%2C%20comic%20illustration%20style%2C%20high%20quality%20dark%20fantasy%20art&width=400&height=540&seq=comic-cover-03&orientation=portrait',
    category: 'fantasy',
    status: '连载中',
    rating: 9.7,
    views: '980万',
    description: '金独子是一个普通的上班族，唯一的爱好就是阅读一本名叫《在灭亡世界中存活的三种方法》的网络小说。当这部连载了十年的小说终于完结时，小说中的世界竟然变成了现实！作为唯一一个知道这个故事全部内容的人，金独子将如何利用他的"全知视角"在这个末日世界里存活下去？',
    chapters: [
      { id: 301, title: '第195话 最后的星座', number: 195, updatedAt: '2024-12-18' },
      { id: 302, title: '第194话 决战的序幕', number: 194, updatedAt: '2024-12-11' },
      { id: 303, title: '第193话 隐藏的真相', number: 193, updatedAt: '2024-12-04' },
      { id: 304, title: '第192话 神话级剧情', number: 192, updatedAt: '2024-11-27' },
      { id: 305, title: '第191话 星流的秘密', number: 191, updatedAt: '2024-11-20' },
      { id: 306, title: '第190话 回归者', number: 190, updatedAt: '2024-11-13' },
    ],
    tags: ['奇幻', '末世', '系统流', '剧情'],
    updatedAt: '2024-12-18',
  },
  {
    id: 4,
    title: '外貌至上主义',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Lookism%20cover%20style%2C%20contrast%20between%20handsome%20and%20overweight%20male%20character%2C%20school%20bullying%20theme%2C%20urban%20street%20background%2C%20dramatic%20split%20composition%2C%20comic%20illustration%20style%2C%20high%20quality%20drama%20art&width=400&height=540&seq=comic-cover-04&orientation=portrait',
    category: 'drama',
    status: '连载中',
    rating: 9.3,
    views: '1120万',
    description: '朴亨硕是一个因为长相和体型而长期遭受校园霸凌的高中生。在一次意外中，他发现自己可以在一个"完美"的身体中醒来。白天他是帅气完美的校园男神，晚上则变回原本的自己。通过这两个截然不同的身份，他开始重新审视这个世界的不公与外表的真正意义。',
    chapters: [
      { id: 401, title: '第450话 新的战场', number: 450, updatedAt: '2024-12-19' },
      { id: 402, title: '第449话 四大帮派', number: 449, updatedAt: '2024-12-12' },
      { id: 403, title: '第448话 完美元', number: 448, updatedAt: '2024-12-05' },
      { id: 404, title: '第447话 幕后黑手', number: 447, updatedAt: '2024-11-28' },
      { id: 405, title: '第446话 联盟', number: 446, updatedAt: '2024-11-21' },
      { id: 406, title: '第445话 真相大白', number: 445, updatedAt: '2024-11-14' },
    ],
    tags: ['校园', '剧情', '格斗', '社会'],
    updatedAt: '2024-12-19',
  },
  {
    id: 5,
    title: '甜蜜家园',
    author: '金坎比 / 黄英璨',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Sweet%20Home%20cover%20style%2C%20apocalyptic%20horror%20theme%2C%20monster%20transformation%2C%20apartment%20building%20surrounded%20by%20monsters%2C%20dark%20night%20atmosphere%2C%20survival%20horror%2C%20comic%20illustration%20style%2C%20high%20quality%20thriller%20art&width=400&height=540&seq=comic-cover-05&orientation=portrait',
    category: 'horror',
    status: '已完结',
    rating: 9.4,
    views: '1350万',
    description: '在家人去世后，性格孤僻的高中生车贤秀搬进了一栋破旧的公寓楼。然而，一场可怕的灾难突然降临——人类开始变异成可怕的怪物，整栋公寓被封锁。被困在公寓中的幸存者们必须与怪物以及内心的欲望作斗争，在这个末日般的地狱中寻找生存的希望。',
    chapters: [
      { id: 501, title: '第141话 终章', number: 141, updatedAt: '2024-08-30' },
      { id: 502, title: '第140话 最后的抉择', number: 140, updatedAt: '2024-08-23' },
      { id: 503, title: '第139话 英雄', number: 139, updatedAt: '2024-08-16' },
      { id: 504, title: '第138话 牺牲', number: 138, updatedAt: '2024-08-09' },
      { id: 505, title: '第137话 希望', number: 137, updatedAt: '2024-08-02' },
      { id: 506, title: '第136话 最后的防线', number: 136, updatedAt: '2024-07-26' },
    ],
    tags: ['恐怖', '末世', '生存', '怪物'],
    updatedAt: '2024-08-30',
  },
  {
    id: 6,
    title: '社内相亲',
    author: 'Haehwa / Narak',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Business%20Proposal%20cover%20style%2C%20romantic%20comedy%2C%20handsome%20CEO%20male%20lead%20in%20suit%2C%20cute%20female%20office%20worker%2C%20bright%20warm%20office%20background%2C%20romantic%20atmosphere%2C%20comic%20illustration%20style%2C%20high%20quality%20romance%20art&width=400&height=540&seq=comic-cover-06&orientation=portrait',
    category: 'romance',
    status: '已完结',
    rating: 9.2,
    views: '890万',
    description: '申夏莉代替闺蜜去参加相亲，本打算故意搞砸，却发现对方竟是自己的公司社长姜泰武！更糟糕的是，社长不但没有拒绝她，反而直接向她求婚。为了不让身份暴露，夏莉必须在这个谎言中越陷越深……一段始于谎言的办公室浪漫喜剧就此展开。',
    chapters: [
      { id: 601, title: '第124话 终章', number: 124, updatedAt: '2024-07-15' },
      { id: 602, title: '第123话 婚礼', number: 123, updatedAt: '2024-07-08' },
      { id: 603, title: '第122话 求婚', number: 122, updatedAt: '2024-07-01' },
      { id: 604, title: '第121话 约会', number: 121, updatedAt: '2024-06-24' },
      { id: 605, title: '第120话 真相', number: 120, updatedAt: '2024-06-17' },
      { id: 606, title: '第119话 危机', number: 119, updatedAt: '2024-06-10' },
    ],
    tags: ['恋爱', '职场', '搞笑', '契约恋爱'],
    updatedAt: '2024-07-15',
  },
  {
    id: 7,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Who%20Made%20Me%20a%20Princess%20cover%20style%2C%20beautiful%20princess%20in%20royal%20dress%2C%20fantasy%20palace%20setting%2C%20elegant%20romantic%20atmosphere%2C%20sparkling%20magical%20elements%2C%20comic%20illustration%20style%2C%20high%20quality%20fantasy%20romance%20art&width=400&height=540&seq=comic-cover-07&orientation=portrait',
    category: 'fantasy',
    status: '已完结',
    rating: 9.6,
    views: '1020万',
    description: '一位现代女性意外穿越到了一本小说中，成为了一位注定要在18岁被自己的父皇处死的公主——阿塔娜西亚。为了改变命运，她开始想尽办法讨好冷酷无情的皇帝父亲克劳德。然而，当她逐渐触动了皇帝冰冷的心时，更大的秘密也在慢慢浮出水面……',
    chapters: [
      { id: 701, title: '第125话 终章', number: 125, updatedAt: '2024-06-20' },
      { id: 702, title: '第124话 幸福的结局', number: 124, updatedAt: '2024-06-13' },
      { id: 703, title: '第123话 父亲的爱', number: 123, updatedAt: '2024-06-06' },
      { id: 704, title: '第122话 真相揭晓', number: 122, updatedAt: '2024-05-30' },
      { id: 705, title: '第121话 危机降临', number: 121, updatedAt: '2024-05-23' },
      { id: 706, title: '第120话 魔法觉醒', number: 120, updatedAt: '2024-05-16' },
    ],
    tags: ['奇幻', '穿越', '恋爱', '皇室'],
    updatedAt: '2024-06-20',
  },
  {
    id: 8,
    title: '僵尸校园',
    author: '朱东根',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20All%20of%20Us%20Are%20Dead%20cover%20style%2C%20zombie%20apocalypse%20in%20high%20school%2C%20students%20running%20from%20zombies%2C%20dark%20emergency%20lighting%2C%20horror%20survival%20theme%2C%20comic%20illustration%20style%2C%20high%20quality%20horror%20thriller%20art&width=400&height=540&seq=comic-cover-08&orientation=portrait',
    category: 'horror',
    status: '已完结',
    rating: 9.1,
    views: '760万',
    description: '孝山高中突然爆发了恐怖的僵尸病毒，被感染的学生和老师变成了嗜血的怪物。被困在校园中的幸存学生们必须想尽办法逃出生天，而校外的世界也正在被这场病毒吞噬。面对接踵而至的危机，这群高中生将如何在这个僵尸末日中存活下去？',
    chapters: [
      { id: 801, title: '第131话 终章', number: 131, updatedAt: '2024-05-10' },
      { id: 802, title: '第130话 希望之光', number: 130, updatedAt: '2024-05-03' },
      { id: 803, title: '第129话 最后的战斗', number: 129, updatedAt: '2024-04-26' },
      { id: 804, title: '第128话 救援来临', number: 128, updatedAt: '2024-04-19' },
      { id: 805, title: '第127话 绝望', number: 127, updatedAt: '2024-04-12' },
      { id: 806, title: '第126话 突围', number: 126, updatedAt: '2024-04-05' },
    ],
    tags: ['恐怖', '校园', '丧尸', '生存'],
    updatedAt: '2024-05-10',
  },
  {
    id: 9,
    title: '恶女是提线木偶',
    author: 'Mango / Suho',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Villainess%20Is%20a%20Marionette%20cover%20style%2C%20elegant%20female%20villainess%20in%20royal%20gown%2C%20fantasy%20palace%20with%20puppet%20strings%20theme%2C%20dark%20romantic%20atmosphere%2C%20intricate%20lace%20details%2C%20comic%20illustration%20style%2C%20high%20quality%20fantasy%20art&width=400&height=540&seq=comic-cover-09&orientation=portrait',
    category: 'fantasy',
    status: '连载中',
    rating: 9.0,
    views: '650万',
    description: '穿越成为小说中恶毒女配的凯耶娜，决定改变自己悲惨的结局。她不再是那个任人摆布的提线木偶，而是要用自己的智慧和魅力，在这个充满阴谋的皇室中掌握自己的命运。然而，当她开始偏离"剧本"时，原本的故事线也开始发生了意想不到的变化。',
    chapters: [
      { id: 901, title: '第98话 王的秘密', number: 98, updatedAt: '2024-12-17' },
      { id: 902, title: '第97话 同盟', number: 97, updatedAt: '2024-12-10' },
      { id: 903, title: '第96话 宫廷舞会', number: 96, updatedAt: '2024-12-03' },
      { id: 904, title: '第95话 暗流涌动', number: 95, updatedAt: '2024-11-26' },
      { id: 905, title: '第94话 意想不到', number: 94, updatedAt: '2024-11-19' },
      { id: 906, title: '第93话 骑士的誓言', number: 93, updatedAt: '2024-11-12' },
    ],
    tags: ['奇幻', '穿越', '恋爱', '恶女'],
    updatedAt: '2024-12-17',
  },
  {
    id: 10,
    title: '看脸时代',
    author: '朴泰俊',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20Lookism%20social%20commentary%20cover%20style%2C%20two%20contrasting%20male%20faces%2C%20school%20bullying%20theme%2C%20urban%20Korean%20street%20scene%2C%20dramatic%20dual%20identity%20concept%2C%20comic%20illustration%20style%2C%20high%20quality%20drama%20art&width=400&height=540&seq=comic-cover-10&orientation=portrait',
    category: 'drama',
    status: '连载中',
    rating: 9.4,
    views: '1400万',
    description: '朴炯硕因为长相和身材长期被校园恶霸欺负，每天过着地狱般的生活。在母亲的支持下，他转学到一个新的环境，但命运给了他一个惊人的改变——他发现自己可以变成一位完美的帅哥。从此，他必须要在两个身体之间切换，体验着截然不同的人生。',
    chapters: [
      { id: 1001, title: '第462话 最终决战', number: 462, updatedAt: '2024-12-21' },
      { id: 1002, title: '第461话 四天王集结', number: 461, updatedAt: '2024-12-14' },
      { id: 1003, title: '第460话 联合行动', number: 460, updatedAt: '2024-12-07' },
      { id: 1004, title: '第459话 地下格斗', number: 459, updatedAt: '2024-11-30' },
      { id: 1005, title: '第458话 新的敌人', number: 458, updatedAt: '2024-11-23' },
      { id: 1006, title: '第457话 暗流', number: 457, updatedAt: '2024-11-16' },
    ],
    tags: ['校园', '剧情', '格斗', '成长'],
    updatedAt: '2024-12-21',
  },
  {
    id: 11,
    title: '今生也请多指教',
    author: '李惠',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20See%20You%20in%20My%2019th%20Life%20cover%20style%2C%20beautiful%20reincarnation%20romance%2C%20female%20lead%20remembering%20past%20lives%2C%20warm%20nostalgic%20atmosphere%2C%20soft%20watercolor%20feel%2C%20comic%20illustration%20style%2C%20high%20quality%20romance%20art&width=400&height=540&seq=comic-cover-11&orientation=portrait',
    category: 'romance',
    status: '已完结',
    rating: 9.5,
    views: '780万',
    description: '潘知音拥有一个特殊的能力——她能记住自己前世的所有记忆。在她的第18世，她爱上了一个叫文瑞夏的男人，但不幸早逝。在第19世，她决定找到瑞夏，重新延续那份未完成的爱情。然而，面对已经长大的瑞夏，她能否再次走进他的心？',
    chapters: [
      { id: 1101, title: '第113话 终章', number: 113, updatedAt: '2024-04-20' },
      { id: 1102, title: '第112话 告白', number: 112, updatedAt: '2024-04-13' },
      { id: 1103, title: '第111话 记忆', number: 111, updatedAt: '2024-04-06' },
      { id: 1104, title: '第110话 选择', number: 110, updatedAt: '2024-03-30' },
      { id: 1105, title: '第109话 过去', number: 109, updatedAt: '2024-03-23' },
      { id: 1106, title: '第108话 缘分', number: 108, updatedAt: '2024-03-16' },
    ],
    tags: ['恋爱', '转世', '治愈', '剧情'],
    updatedAt: '2024-04-20',
  },
  {
    id: 12,
    title: '入赘女婿',
    author: 'Seongwon',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20son-in-law%20revenge%20cover%20style%2C%20handsome%20male%20lead%20in%20formal%20attire%2C%20wealthy%20family%20mansion%20background%2C%20dramatic%20corporate%20theme%2C%20cold%20atmosphere%20with%20hidden%20tension%2C%20comic%20illustration%20style%2C%20high%20quality%20drama%20art&width=400&height=540&seq=comic-cover-12&orientation=portrait',
    category: 'drama',
    status: '连载中',
    rating: 8.9,
    views: '520万',
    description: '被岳父家族瞧不起的入赘女婿李建，默默忍受了三年的屈辱。直到有一天，他的真实身份被揭穿——他竟是某神秘组织的幕后掌控者。曾经欺辱他的人们开始惶恐不安，而李建的复仇计划才刚刚开始。一场关于权力、尊严与复仇的精彩故事！',
    chapters: [
      { id: 1201, title: '第88话 摊牌', number: 88, updatedAt: '2024-12-16' },
      { id: 1202, title: '第87话 岳父的恐惧', number: 87, updatedAt: '2024-12-09' },
      { id: 1203, title: '第86话 身份曝光', number: 86, updatedAt: '2024-12-02' },
      { id: 1204, title: '第85话 暗中布局', number: 85, updatedAt: '2024-11-25' },
      { id: 1205, title: '第84话 家族内斗', number: 84, updatedAt: '2024-11-18' },
      { id: 1206, title: '第83话 反击', number: 83, updatedAt: '2024-11-11' },
    ],
    tags: ['剧情', '复仇', '爽文', '都市'],
    updatedAt: '2024-12-16',
  },
];

export function getComicById(id: number): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(category: string): Comic[] {
  return comics.filter((c) => c.category === category);
}

export function getFeaturedComics(): Comic[] {
  return comics.filter((c) => c.rating >= 9.4).slice(0, 8);
}

export function getLatestUpdates(): Comic[] {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);
}

export function getPopularComics(): Comic[] {
  return [...comics].sort((a, b) => parseFloat(b.views.replace('万', '')) - parseFloat(a.views.replace('万', ''))).slice(0, 6);
}

export function getRelatedComics(comic: Comic, limit: number = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && c.category === comic.category)
    .slice(0, limit);
}